<template>
	<page-container :page="page">
		<heading-image
			v-if="page.headingImage"
			:heading-image="{
				image: page.headingImage,
				imageWebp: page.headingImageWebp,
				imagePortrait: page.headingImagePortrait,
				imagePortraitWebp: page.headingImagePortraitWebp,
			}"
		/>
		<main-content :title="page.title || page.header" :content="page.content">
			<template #extra-heading>
				<p v-if="page.date">
					<strong>{{ $d(new Date(page.date.date.split(' ')[0]), 'long', locale) }}</strong>
				</p>
			</template>
			<template v-if="page.midSectionImage" #extra-content>
				<div class="columns column12">
					<picture>
						<source :srcset="page.midSectionImageWebp" type="image/webp" />
						<source :srcset="page.midSectionImage" />
						<img :src="page.midSectionImage" :alt="page.midSectionImageAlt" loading="lazy" />
					</picture>
				</div>
			</template>
		</main-content>

		<section class="main-content background-light">
			<div class="row blocks-header">
				<div class="columns column12 align-center">
					<h2>{{ $t('moreNews') }}</h2>
				</div>
			</div>
			<div class="row">
				<div v-for="item in other" :key="item.ID" class="columns column12">
					<fullwidth-block :item="item" />
				</div>
			</div>
			<div class="row">
				<div class="columns column12 align-center">
					<nuxt-link class="button" :to="localePath('news', locale)">
						{{ $t('allNews') }}
					</nuxt-link>
				</div>
			</div>
		</section>
	</page-container>
</template>

<script setup>
const { page, fetchPage } = usePage();
const { locale } = useI18n();

await fetchPage();
</script>
